/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileAvi = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M16.099 17h-1.2l-.333-1.028h-1.851L12.387 17h-1.153l1.905-5.017h1.042zm-3.093-1.938h1.267l-.638-1.973zm5.024.614 1.185-3.693h1.166L18.532 17H17.49l-1.85-5.017h1.215zM21.997 17h-1.076v-5.017h1.076z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileAvi as FileAvi };
